<template>
  <div class="row">
    <div class="col-sm-3">
      <div
        class="form-group"
        :class="{
          'has-error has-feedback': error,
          'has-success has-feedback': success,
        }"
      >
        <input
          :id="attestation.id"
          :name="attestation.id"
          type="text"
          :value="value"
          @input="onInput"
          class="form-control"
        />
        <span
          v-if="value"
          :class="{
            'glyphicon-ok': success,
            'glyphicon-remove': error,
          }"
          class="glyphicon form-control-feedback"
        ></span>
        <span v-if="error" class="help-block">Type "{{ initials }}" here</span>
      </div>
    </div>
    <div class="col-sm-9">
      <p v-html="attestation.attestation"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'attestations-form-item',
  props: {
    attestation: {
      type: Object,
    },
    initials: {
      type: String,
    },
    value: {
      type: String,
    },
  },
  computed: {
    error() {
      return this.value !== undefined && !this.valid;
    },
    success() {
      return this.value !== undefined && this.valid;
    },
    valid() {
      return !this.initials || this.value === this.initials;
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-control-feedback {
  visibility: visible;
}
</style>
